const rankingItems = [
  { rank: 1, title: '我独自升级', type: '奇幻/动作', score: '9.7', hot: '🔥' },
  { rank: 2, title: '全知读者视角', type: '奇幻/悬疑', score: '9.6', hot: '🔥' },
  { rank: 3, title: '反派小姐的男主人公', type: '恋爱/奇幻', score: '9.5', hot: '🔥' },
  { rank: 4, title: '剑尊归来', type: '动作/武侠', score: '9.4', hot: '📈' },
  { rank: 5, title: '入坑韩漫指南', type: '恋爱/校园', score: '9.3', hot: '📈' },
  { rank: 6, title: '伯爵家的废物', type: '奇幻/重生', score: '9.2', hot: '🔥' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            本周韩漫下载热门排行，看看大家都在追什么
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={item.title}
              href="#ranking"
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-4 transition-colors cursor-pointer hover:bg-primary-50/50 ${
                idx !== rankingItems.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold shrink-0 ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs shrink-0">{item.hot}</span>
                </div>
                <div className="text-xs text-foreground-400 mt-0.5">{item.type}</div>
              </div>

              <div className="flex items-center gap-1 shrink-0">
                <i className="ri-star-fill text-accent-500 text-sm"></i>
                <span className="text-sm font-bold text-foreground-800">{item.score}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}